module.exports = __webpack_public_path__ + "static/noticias-14-233a45e480a53b6608361d0648aad88f.jpg";